import configs from "../sessionConfig"
import { EnvironmentLevelKeys } from "../../config/environmentConfigs/configTypes"
const serverRoot = {
  US3: "us3-server-node0.hoolva.com",
  prod: "ncsapp.com",
  US1: "us1-dev.hoolva.com",
  NCS: "us3-test.ncsapp.com",
  US7: "us7-cluster.hoolva.com",
  US2: "us2-stage.ncsapp.com",
  US9: "us9-dev.ncsapp.com",
  US11: "us11-dev.ncsapp.com",
  ONE: "phone.vaspian.com",
  ONETEST: "test-phone.vaspian.com",
  US1_NCS: "us1-dev.ncsapp.com",
  US5_NCS: "us5-dev.ncsapp.com",
  BDB: 'ncs.bbdtel.com'
}

export const DocumentRoot = [
  {
    domain: "us7-cluster.hoolva.com",
    env: "test",
  },
  {
    domain: "us9-dev.ncsapp.com",
    env: "us9",
  },
  {
    domain: "us11-dev.ncsapp.com",
    env: "us11",
  },
  {
    domain: "us3-test.ncsapp.com",
    env: "dev",
  },
  {
    domain: "ncs.bbdtel.com",
    env: "BBD",
  },
  {
    domain: "us2-stage.ncsapp.com",
    env: "staging",
  },
  {
    domain: "ncsapp.com",
    env: "prod",
  },
  {
    domain: "phone.vaspian.com",
    env: "one",
  },
  {
    domain: "test-phone.vaspian.com",
    env: "onetest",
  },
]

class Environment {
  static instance: Environment
  rootUrl: string
  keycloak_rootUrl: string
  keycloak_reg: string
  keycloak_logout: string
  keycloak_tenant_login: string
  siloute_api: string
  tenant_info_api: string
  update_display_name: string
  personal_status: string
  update_user: (value: string) => string
  keycloak_get_tenant: (value: string) => string
  keycloak_api_login: (value: string) => string
  forgot_password: string
  EnvironmentLevel: EnvironmentLevelKeys
  apikey: string
  loglevel: number

  private constructor(
    env: EnvironmentLevelKeys,
    apikey: string,
    loglevel: number
  ) {
    this.EnvironmentLevel = env
    this.apikey = apikey
    this.loglevel = loglevel
    if (env === "PRODUCTION") {
      this.rootUrl = `https://${serverRoot.prod}/app`
      this.keycloak_rootUrl = `https://${serverRoot.prod}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.prod}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.prod}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.prod}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.prod}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.prod}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.prod}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.prod}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.prod}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.prod}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://${serverRoot.prod}/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.prod}/v2/reset_password`
    } else if (env === "GAMMADEVELOP") {
      this.rootUrl = `https://${serverRoot.US9}/app`
      this.keycloak_rootUrl = `https://${serverRoot.US9}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.US9}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.US9}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.US9}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.US9}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.US9}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.US9}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.US9}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.US9}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.US9}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://${serverRoot.US9}/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.US9}/v2/reset_password`
    } else if (env === "GAMMASANBOX") {
      this.rootUrl = `https://${serverRoot.US11}/app`
      this.keycloak_rootUrl = `https://${serverRoot.US11}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.US11}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.US11}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.US11}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.US11}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.US11}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.US11}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.US11}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.US11}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.US11}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://${serverRoot.US11}/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.US11}/v2/reset_password`
    } else if (env === "BROADBAND") {
      this.rootUrl = `https://${serverRoot.BDB}/app`
      this.keycloak_rootUrl = `https://${serverRoot.BDB}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.BDB}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.BDB}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.BDB}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.BDB}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.BDB}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.BDB}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.BDB}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.BDB}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.BDB}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://${serverRoot.BDB}/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.BDB}/v2/reset_password`
    } else if (env === "VASPIANPROD") {
      this.rootUrl = `https://${serverRoot.ONE}/app`
      this.keycloak_rootUrl = `https://${serverRoot.ONE}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.ONE}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.ONE}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.ONE}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.ONE}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.ONE}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.ONE}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.ONE}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.ONE}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.ONE}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://${serverRoot.ONE}/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.ONE}/v2/reset_password`
    } else if (env === "NCSTEST") {
      this.rootUrl = `https://${serverRoot.NCS}/app`
      this.keycloak_rootUrl = `https://${serverRoot.NCS}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.NCS}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.NCS}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.NCS}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.NCS}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.NCS}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.NCS}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.NCS}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.NCS}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.NCS}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://${serverRoot.NCS}/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.NCS}/v2/reset_password`
    } else if (env === "VASPIANTEST") {
      this.rootUrl = `https://${serverRoot.ONETEST}/app`
      this.keycloak_rootUrl = `https://${serverRoot.ONETEST}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.ONETEST}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.ONETEST}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.ONETEST}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.ONETEST}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.ONETEST}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.ONETEST}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.ONETEST}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.ONETEST}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.ONETEST}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://${serverRoot.ONETEST}/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.ONETEST}/v2/reset_password`
    } else if (env === "DEVELOPMENT") {
      this.rootUrl = `https://${serverRoot.US1}/app`
      this.keycloak_rootUrl = `https://${serverRoot.US1}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.US1}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.US1}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.US1}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.US1}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.US1}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.US1}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.US1}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.US1}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.US1}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://us3-test.hoolva.com/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.US1}/v2/reset_password`
    } else if (env === "STAGING-3") {
      this.rootUrl = `https://${serverRoot.US2}/app`
      this.keycloak_rootUrl = `https://${serverRoot.US2}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.US2}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.US2}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.US2}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.US2}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.US2}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.US2}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.US2}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.US2}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.US2}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://${serverRoot.US2}/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.US2}/v2/reset_password`
    } else if (env === "SANDBOX") {
      this.rootUrl = `https://${serverRoot.US7}/app`
      this.keycloak_rootUrl = `https://${serverRoot.US7}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.US7}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.US7}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.US7}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.US7}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.US7}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.US7}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.US7}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.US7}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.US7}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://us1dev-ncs.kanimango.com/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.US7}/v2/reset_password`
    } else if (env === "KANIMANGOTHREE") {
      this.rootUrl = `https://${serverRoot.US1}/app`
      this.keycloak_rootUrl = `https://${serverRoot.US1}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.US1}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.US1}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.US1}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.US1}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.US1}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.US1}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.US1}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.US1}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.US1}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://us3-test.hoolva.com/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.US1}/v2/reset_password`
    } else if (env === "ALPHADEVELOP") {
      this.rootUrl = `https://${serverRoot.US1_NCS}/app`
      this.keycloak_rootUrl = `https://${serverRoot.US1_NCS}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.US1_NCS}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.US1_NCS}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.US1_NCS}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.US1_NCS}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.US1_NCS}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.US1_NCS}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.US1_NCS}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.US1_NCS}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.US1_NCS}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://${serverRoot.US1_NCS}/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.US1_NCS}/v2/reset_password`
    } else if (env === "ALPHASANDBOX") {
      this.rootUrl = `https://${serverRoot.US5_NCS}/app`
      this.keycloak_rootUrl = `https://${serverRoot.US5_NCS}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.US5_NCS}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.US5_NCS}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.US5_NCS}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.US5_NCS}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.US5_NCS}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.US5_NCS}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.US5_NCS}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.US5_NCS}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.US5_NCS}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://${serverRoot.US5_NCS}/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.US5_NCS}/v2/reset_password`
    } else {
      console.log(env, 'TEST.2222')

      this.rootUrl = `https://${serverRoot.US3}/app`
      this.keycloak_rootUrl = `https://${serverRoot.US3}/sso/?d=desk&q=`
      this.keycloak_reg = `https://${serverRoot.US3}/sso/?d=desk&q=signup`
      this.keycloak_logout = `https://${serverRoot.US3}/v1/logout/user`
      this.keycloak_tenant_login = `https://${serverRoot.US3}/v2/email/clients?email=`
      this.tenant_info_api = `https://${serverRoot.US3}/v1/getTenantInfo`
      this.siloute_api = `https://${serverRoot.US3}/v1/telco/system/tenant/system/siloute`
      this.update_display_name = `https://${serverRoot.US3}/v1/updateUser/null`
      this.personal_status = `https://${serverRoot.US3}/v1/chat/changePersonalStatus`
      this.update_user = (value: string) =>
        `https://${serverRoot.US3}/v1/updateUser/${value}`
      this.keycloak_get_tenant = (userName: string) =>
        `https://${serverRoot.US3}/v2/email/clients?email=${userName}`
      this.keycloak_api_login = (name: string) =>
        `https://${serverRoot.US3}/auth/realms/${name}/protocol/openid-connect/token`
      this.forgot_password = `https://${serverRoot.US3}/v2/reset_password`
    }
  }

  public static getInstance(): Environment {
    if (!Environment.instance) {
      Environment.instance = new Environment(
        configs.environmentLevel,
        configs.apiKey,
        configs.logLevel
      )
    }
    return Environment.instance
  }
}

export { Environment, serverRoot }
